// extracted by mini-css-extract-plugin
module.exports = {"details-popup":"DetailsPopup_details-popup__BcnGB"};